var map = {
	"./egypt_icon.svg": 6407,
	"./india_icon.svg": 26499,
	"./kenya_icon.svg": 13912,
	"./kenya_icon_old.svg": 17426,
	"./laos_icon.svg": 27313,
	"./nepal_icon.svg": 81774,
	"./thailand_icon.svg": 70227,
	"./uzbekistan_icon.svg": 82738,
	"./vietnam_icon.svg": 32488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89528;